import { render, staticRenderFns } from "./InvoiceAging.vue?vue&type=template&id=29efe722&scoped=true&"
import script from "./InvoiceAging.vue?vue&type=script&lang=js&"
export * from "./InvoiceAging.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAging.vue?vue&type=style&index=0&id=29efe722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29efe722",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFadeTransition,VRow})
